import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";
import HeaderContent from "../headerContent";
import { bindActionCreators } from "redux";
import * as settingsActions from "../../store/actions/permissions.js";
import { StandardTabs, Tab } from "@ts-digital/vrc";
import Settings from ".";
import "./style.css";
import * as companiesActions from "../../store/actions/company/index";
import SettingsUsersTable from "./settings-users-table";
import { useLocation, useNavigate } from "react-router-dom";

const SettingsComponent = (props) => {
  const {
    auth,
    currentPermissions,
    clientIdSelected,
    company,
    companySelected,
    savePermissions,
    accountantSelected,
    accountantIdSelected,
    companyUuidSelected,
    accountantUuidSelected,
    getUsersList,
    getPermissionsClientsList,
    getSettingsCompany,
    servicesAgyo,
    // loadCompanyForSettings
    // searchUsersByParams
  } = props;
  const [activeTab, setActiveTab] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  const intl = useIntl();
  // const [queryParameters, setQueryParameters] = useState({
  //   lastName: "",
  //   firstName: "",
  //   authId: ""
  // });
  //   const [queryParamChanged, setQueryParamChanged] = useState(false);
  //   useEffect(() => {
  //     getUsersByItemId(auth, clientIdSelected);
  //   }, [clientIdSelected]);
  // const onChangeFilter = (name, event) => {
  //   switch (name) {
  //     case "lastName":
  //       queryParameters["lastName"] = event.target.value;
  //       break;
  //     case "firstName":
  //       queryParameters["firstName"] = event.target.value;
  //       break;
  //     case "authId":
  //       queryParameters["authId"] = event.target.value;
  //       break;
  //     default: {
  //       break;
  //     }
  //   }
  //   setQueryParameters(queryParameters);
  //   // setQueryParamChanged(true);
  // };

  // TO DO: Per filtrare i campi di ricerca occorre una chiamata lato BE
  //   useEffect(() => {
  //
  //     if (!usersList.list) {
  //       return;
  //     }
  //     searchUsersByParams(queryParameters, usersList.list.users);
  //     setQueryParamChanged(false);
  //   }, [queryParamChanged]);
  const [isOwner, setIsOwner] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const roles = useSelector((state) => state.user.roles);
  const main = useSelector((state) => state.main);
  const myType = main.myType;

  useEffect(() => {
    const isOwnerResources = roles.filter((resource) => resource.actionKey === "OWNER" && (resource.appId === "DBX" || resource.appId === null));
    const isAdminResources = roles.filter((resource) => resource.actionKey === "ADMIN" && (resource.appId === "DBX" || resource.appId === null));
    const currentStudioForOwner = isOwnerResources.filter((res) => res.resourceId === accountantIdSelected);
    const currentStudioForAdmin = isAdminResources.filter((res) => res.resourceId === accountantIdSelected);
    setIsOwner(currentStudioForOwner.length > 0 ? true : false);
    setIsAdmin(currentStudioForAdmin.length > 0 ? true : false);
  }, [roles, accountantIdSelected]);

  const ragioneSocialeAzienda = company?.companies.find((el) => {
    return el.id === clientIdSelected;
  })?.ragioneSociale;

  return (
    <div className="contentStructure transparent settings">
      <HeaderContent
        location={location}
        navigate={navigate}
        isPremiumAdvice={myType === "STUDIO"}
        title={intl?.formatMessage({ id: "settings.title" })}
        servicesAgyo={servicesAgyo}
      />
      <div style={{ backgroundColor: "#ffffff" }}>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            width: "100%",
            marginBottom: activeTab === 1 ? "40px" : "0",
          }}
        >
          <StandardTabs
            style={{ overflow: "hidden", width: "100%" }}
            activeIndex={activeTab}
            onChange={(e) => {
              setActiveTab(e);
            }}
          >
            <Tab className="styleTab" key={0} style={{ width: "15%" }}>
              <FormattedMessage id="settings.clients" />
            </Tab>
            {isOwner || isAdmin ? (
              <Tab className="styleTab" key={1} style={{ width: "15%" }}>
                <FormattedMessage id="settings.users" />
              </Tab>
            ) : (
              <div></div>
            )}
            <Tab className="styleTab" key={2} style={{ width: "100%" }} disabled={true}></Tab>
          </StandardTabs>
        </div>
        {activeTab === 0 && (
          <Settings
            auth={auth}
            currentPermissions={currentPermissions}
            clientIdSelected={clientIdSelected}
            company={company}
            companySelected={companySelected}
            companyUuidSelected={companyUuidSelected}
            accountantUuidSelected={accountantUuidSelected}
            savePermissions={savePermissions}
            accountantSelected={accountantSelected}
            accountantIdSelected={accountantIdSelected}
            getUsersList={getUsersList}
            getPermissionsClientsList={getPermissionsClientsList}
            getSettingsCompany={getSettingsCompany}
            myType={myType}
            servicesAgyo={servicesAgyo}
          />
        )}
        {activeTab === 1 && (
          <>
            <span className="labelUsersCompany">
              <FormattedMessage id="settings.usersCompany" /> <strong> {ragioneSocialeAzienda} </strong>
            </span>
            <div className="usersContainer">
              <SettingsUsersTable
                myType={myType}
                auth={auth}
                companySelected={companySelected}
                companyUuidSelected={companyUuidSelected}
                accountantUuidSelected={accountantUuidSelected}
                clientIdSelected={clientIdSelected}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};
function mapStateToProps(state) {
  return {
    auth: state.auth,
    usersList: state.usersList,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    companiesActions: bindActionCreators(companiesActions, dispatch),
    getPermissionsClientsList: bindActionCreators(settingsActions.getPermissionsClientsList, dispatch),
    // searchUsersByParams: bindActionCreators(
    //   companiesActions.searchUsersByParams,
    //   dispatch
    // )
    // getUsersByItemId: (auth, companyId) => {
    //   dispatch(companiesActions.getUsersByItemId(auth, companyId));
    // }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SettingsComponent);
